import { render, staticRenderFns } from "./slideUpPop.vue?vue&type=template&id=5f27ac70&"
import script from "./slideUpPop.vue?vue&type=script&setup=true&lang=js&"
export * from "./slideUpPop.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports